import axiosInstance from "../axiosInstance";

const BASE = "/server/buccl_user/notifications/";

export const notificationsService = {
  list: (params?: Record<string, unknown>) => axiosInstance.get(BASE, { params }),
  get: (id: number) => axiosInstance.get(`${BASE}${id}/`),
  markRead: (id: number) => axiosInstance.post(`${BASE}${id}/mark_as_read/`),
  markAllRead: () => axiosInstance.post(`${BASE}mark_all_as_read/`),
  remove: (id: number) => axiosInstance.delete(`${BASE}${id}/`),
  unreadCount: () => axiosInstance.get(`${BASE}unread-count/`),
  // 기기 관리
  registerDevice: (payload: Record<string, unknown>) => axiosInstance.post(`${BASE}register-device/`, payload),
  unregisterDevice: (payload: { device_token: string }) => axiosInstance.post(`${BASE}unregister-device/`, payload),
};
